exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "textarea {\n  max-height: 60vh; }\n\n.wrapper-deposit-detail {\n  max-height: 55vh;\n  overflow-y: auto; }\n  .wrapper-deposit-detail .header-deposit-list {\n    background-color: #1464f6;\n    color: #fff;\n    text-align: center;\n    display: -ms-flexbox;\n    display: flex; }\n    .wrapper-deposit-detail .header-deposit-list .item {\n      padding: 5px;\n      border-right: 1px solid white;\n      -ms-flex: 1;\n          flex: 1; }\n  .wrapper-deposit-detail .body-deposit-list {\n    display: -ms-flexbox;\n    display: flex; }\n    .wrapper-deposit-detail .body-deposit-list input.item {\n      margin: 1.3px !important; }\n\n.buttons-and-info {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  margin: 8px 0; }\n  .buttons-and-info .m-btn-margins {\n    margin: 0 4px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/deposits/deposits-details-copy-paste/deposits-details-copy-paste.component.scss
// module id = 1964
// module chunks = 66